import React, { Component } from 'react';
import { GeckoIcon } from '../../../../components';
import './styles.css';
import moment from 'moment';

export class SessionTable extends Component {
    constructor(props) {
        super(props);

        this.renderRows = this.renderRows.bind(this);
    }


    renderRows(data) {
        return data.map((session, key) => {
            return <div key={key}> <ActivityRow SetId={session.SetId} SetName={session.SetName} Client={session.Client} IdToken={session.IdToken} AccessToken={session.AccessToken} RefreshToken={session.RefreshToken} revokeToken={this.props.revoke} /></div>;
        })
    }

    render() {
        return (
            <div className="SessionTable">
                {this.renderRows(this.props.data)}
            </div>

        )
    }
}

SessionTable.defaultProps = {
    data: [],
}


export const ActivityRow = ({SetId, SetName, Client, IdToken, AccessToken, RefreshToken, revokeToken}) => {
    const isAPIToken = (Client === 'api' ? true : false);

    return (
        <div className="eventRow">
            <div className="d-flex flex-row ">
                <div className="eventType d-flex flex-row align-items-center">
                    <span>{SetName}</span> 
                    {EventResponseBadge(Client)}
                </div>
            </div>

            { !isAPIToken &&
                 <div className="SessionTable-ActivityRow-tokenMeta">
                    Logged in using a browser
                </div>
            }
           
            { isAPIToken &&
                <div className="d-flex flex-column primary flex-wrap ">
                    <div className="meta" title="Device Name">Id Token: <code>{IdToken}</code></div>
                    <div className="meta" title="Timestamp">Access Token: <code>{AccessToken}</code></div>
                    <div className="meta" title="Country">Refresh Token: <code>{RefreshToken}</code></div>
                </div>
            }

            <div className="deleteBtn" onClick={() => revokeToken(SetId)}>
                <GeckoIcon icon="trash" />
            </div>
        </div>
    );
}

export const EventResponseBadge = (value) => {
    if (!value || value === '') {
        return null;
    }

    if (value === 'Fail') {
        return <span className="activityBadge activityFailed">Failed</span>
    }

    return <span className="activityBadge activityFailed">{value}</span>
}

export default SessionTable;